var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 4.16602H6.16667C5.24619 4.16602 4.5 4.91221 4.5 5.83268V14.166C4.5 15.0865 5.24619 15.8327 6.16667 15.8327H17.8333C18.7538 15.8327 19.5 15.0865 19.5 14.166V5.83268C19.5 4.91221 18.7538 4.16602 17.8333 4.16602Z",
    stroke: "#4A4A68",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08398 9.58398C9.77434 9.58398 10.334 9.02434 10.334 8.33398C10.334 7.64363 9.77434 7.08398 9.08398 7.08398C8.39363 7.08398 7.83398 7.64363 7.83398 8.33398C7.83398 9.02434 8.39363 9.58398 9.08398 9.58398Z",
    fill: "#4A4A68",
    stroke: "#4A4A68",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 13.3327L14.5 9.16602L8.25 15.8327",
    stroke: "#4A4A68",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.7614b3c00d87117133adf5b72665cfd1.svg";
export { ForwardRef as ReactComponent };